import { render, staticRenderFns } from "./KegiatanPelayananGigi.vue?vue&type=template&id=7ca99330"
import script from "./KegiatanPelayananGigi.vue?vue&type=script&lang=js"
export * from "./KegiatanPelayananGigi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca99330')) {
      api.createRecord('7ca99330', component.options)
    } else {
      api.reload('7ca99330', component.options)
    }
    module.hot.accept("./KegiatanPelayananGigi.vue?vue&type=template&id=7ca99330", function () {
      api.rerender('7ca99330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananGigi.vue"
export default component.exports